module.exports = __webpack_public_path__ + "images/4585ffb54fab3023d8e6d3ef9afe56d2.png";